(function () {
	console.log('🚀 TOC: Main script loaded and executing');

	// Initialize existing functionality
	pagination(true);

	console.log('🚀 TOC: About to initialize Table of Contents...');
	console.log('🚀 TOC: Document ready state:', document.readyState);

	// Initialize Table of Contents when DOM is ready
	if (document.readyState === 'loading') {
		console.log('🚀 TOC: DOM still loading, adding event listener');
		document.addEventListener('DOMContentLoaded', function () {
			initTableOfContents();
			initSocialShare();
		});
	} else {
		console.log('🚀 TOC: DOM already ready, initializing immediately');
		initTableOfContents();
		initSocialShare();
	}

	// ============================================================================
	// TABLE OF CONTENTS FUNCTIONALITY
	// ============================================================================

	function initTableOfContents() {
		console.log('🔍 TOC: Initializing Table of Contents...');

		const tocContainer = document.getElementById('table-of-contents');
		const tocList = document.getElementById('toc-list');
		const contentArea = document.querySelector('.gh-content');

		console.log('🔍 TOC: Found elements:', {
			tocContainer: !!tocContainer,
			tocList: !!tocList,
			contentArea: !!contentArea,
		});

		// Try alternative content selectors if first one fails
		let actualContentArea = contentArea;
		if (!actualContentArea) {
			console.log('🔍 TOC: .gh-content not found, trying alternatives...');
			actualContentArea =
				document.querySelector('.gh-content') ||
				document.querySelector('.post-content') ||
				document.querySelector('.content') ||
				document.querySelector('article .gh-canvas');
			console.log('🔍 TOC: Alternative content area:', !!actualContentArea);
		}

		// Exit if no TOC container or content area
		if (!tocContainer || !tocList || !actualContentArea) {
			console.log('❌ TOC: Missing required elements, exiting');
			return;
		}

		console.log(
			'🔍 TOC: Content area HTML preview:',
			actualContentArea.innerHTML.substring(0, 200) + '...'
		);

		// Generate TOC
		const tocData = generateTOC(actualContentArea);

		console.log('🔍 TOC: Generated data:', {
			headingsCount: tocData.headings.length,
			tocItemsCount: tocData.tocItems.length,
			headings: tocData.headings.map((h) => ({
				tag: h.tagName,
				text: h.textContent.trim().substring(0, 50),
			})),
		});

		// Only show TOC if we have 2 or more headings
		if (tocData.headings.length >= 2) {
			console.log(
				'✅ TOC: Showing TOC with',
				tocData.headings.length,
				'headings'
			);
			renderTOC(tocList, tocData.tocItems);
			tocContainer.classList.add('has-headings');

			// Add navigation functionality
			handleTOCNavigation(tocList);

			// Add scroll highlighting
			initScrollHighlighting(tocData.headings);
		} else {
			console.log(
				'⚠️  TOC: Not enough headings found (',
				tocData.headings.length,
				'), TOC will remain hidden'
			);
		}
	}

	function generateTOC(contentArea) {
		console.log('🔍 TOC: Generating TOC from content area:', contentArea);

		// Get both regular headings and strong elements within paragraphs
		const regularHeadings = Array.from(
			contentArea.querySelectorAll('h1, h2, h3, h4, h5, h6')
		);

		// Get strong elements that are truly the first meaningful content in their paragraph
		const strongElements = Array.from(
			contentArea.querySelectorAll('p strong')
		).filter((strong) => {
			const paragraph = strong.parentElement;

			// Get all text nodes and elements before the strong element
			const beforeStrong = [];
			let currentNode = paragraph.firstChild;

			while (currentNode && currentNode !== strong) {
				if (currentNode.nodeType === Node.TEXT_NODE) {
					const text = currentNode.textContent.trim();
					if (text.length > 0) {
						beforeStrong.push(text);
					}
				} else if (currentNode.nodeType === Node.ELEMENT_NODE) {
					const text = currentNode.textContent.trim();
					if (text.length > 0) {
						beforeStrong.push(text);
					}
				}
				currentNode = currentNode.nextSibling;
			}

			// Check if there's any meaningful content before the strong
			const hasContentBefore = beforeStrong.length > 0;

			// Get content after strong (allowing only formatting like <br>)
			const afterStrongHTML = paragraph.innerHTML.substring(
				paragraph.innerHTML.indexOf(strong.outerHTML) + strong.outerHTML.length
			);

			const cleanAfterStrong = afterStrongHTML
				.replace(/<br\s*\/?>/gi, '')
				.replace(/&nbsp;/gi, '')
				.replace(/\s+/g, '')
				.trim();

			console.log(
				`🔍 TOC: Checking strong "${strong.textContent.trim()}"`,
				`\n  - Has content before: ${hasContentBefore}`,
				`\n  - Content before: [${beforeStrong.join(', ')}]`,
				`\n  - Clean after: "${cleanAfterStrong}"`
			);

			// Only include if:
			// 1. No meaningful content before the strong
			// 2. Content after is minimal (just formatting)
			return !hasContentBefore && cleanAfterStrong.length < 10;
		});

		// Combine and sort by document order
		const allElements = [...regularHeadings, ...strongElements];
		const headings = allElements.sort((a, b) => {
			const position = a.compareDocumentPosition(b);
			return position & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
		});

		console.log('🔍 TOC: Found headings:', headings.length);
		headings.forEach((heading, index) => {
			console.log(
				`🔍 TOC: Heading ${index + 1}: ${
					heading.tagName
				} - "${heading.textContent.trim()}"`
			);
		});

		const tocItems = [];
		const existingIds = new Set();

		headings.forEach((heading, index) => {
			// Generate unique ID if heading doesn't have one
			let headingId = heading.id;
			if (!headingId) {
				headingId = generateHeadingId(heading.textContent, existingIds);
				heading.id = headingId;
				console.log(
					`🔍 TOC: Generated ID for "${heading.textContent.trim()}": ${headingId}`
				);
			} else {
				console.log(
					`🔍 TOC: Using existing ID for "${heading.textContent.trim()}": ${headingId}`
				);
			}
			existingIds.add(headingId);

			// Get heading level (1-6 for H tags, 3 for STRONG elements)
			let level;
			if (heading.tagName.toLowerCase() === 'strong') {
				level = 3; // Treat strong elements as level 3 headings
			} else {
				level = parseInt(heading.tagName.charAt(1));
			}

			// Create TOC item
			const tocItem = {
				id: headingId,
				text: heading.textContent.trim(),
				level: level,
				element: heading,
			};

			tocItems.push(tocItem);
			console.log(`🔍 TOC: Created TOC item:`, tocItem);
		});

		console.log('🔍 TOC: Final TOC data:', {
			headings: headings.length,
			tocItems: tocItems.length,
		});

		return {
			headings: headings,
			tocItems: tocItems,
		};
	}

	function generateHeadingId(text, existingIds) {
		// Create slug from heading text
		let slug = text
			.toLowerCase()
			.trim()
			.replace(/[^\w\s-]/g, '') // Remove special characters
			.replace(/\s+/g, '-') // Replace spaces with hyphens
			.replace(/-+/g, '-') // Replace multiple hyphens with single
			.replace(/^-|-$/g, ''); // Remove leading/trailing hyphens

		// Ensure uniqueness
		let uniqueSlug = slug;
		let counter = 1;
		while (existingIds.has(uniqueSlug)) {
			uniqueSlug = `${slug}-${counter}`;
			counter++;
		}

		return uniqueSlug;
	}

	function renderTOC(tocList, tocItems) {
		console.log('🔍 TOC: Rendering TOC with', tocItems.length, 'items');
		console.log('🔍 TOC: TOC items to render:', tocItems);

		const tocHTML = tocItems
			.map((item, index) => {
				const itemHTML = `<li class="gh-toc-item level-${item.level}">
                <a href="#${item.id}" class="gh-toc-link" data-target="${
					item.id
				}">
                    ${escapeHtml(item.text)}
                </a>
            </li>`;
				console.log(`🔍 TOC: Item ${index + 1} HTML:`, itemHTML);
				return itemHTML;
			})
			.join('');

		console.log('🔍 TOC: Final TOC HTML:', tocHTML);
		console.log('🔍 TOC: TOC List element:', tocList);

		tocList.innerHTML = tocHTML;

		console.log('🔍 TOC: TOC List innerHTML after setting:', tocList.innerHTML);
		console.log('✅ TOC: TOC rendering complete');
	}

	function handleTOCNavigation(tocList) {
		tocList.addEventListener('click', function (e) {
			const link = e.target.closest('.gh-toc-link');
			if (!link) return;

			e.preventDefault();

			const targetId = link.getAttribute('data-target');
			const targetElement = document.getElementById(targetId);

			if (targetElement) {
				smoothScrollToElement(targetElement);

				// Update URL hash without jumping
				if (history.pushState) {
					history.pushState(null, null, `#${targetId}`);
				}

				// Focus target for accessibility
				targetElement.setAttribute('tabindex', '-1');
				targetElement.focus();

				// Remove tabindex after focus to avoid affecting normal tab order
				setTimeout(() => {
					targetElement.removeAttribute('tabindex');
				}, 100);
			}
		});

		// Handle keyboard navigation
		tocList.addEventListener('keydown', function (e) {
			if (e.key === 'Enter' || e.key === ' ') {
				const link = e.target.closest('.gh-toc-link');
				if (link) {
					e.preventDefault();
					link.click();
				}
			}
		});
	}

	function smoothScrollToElement(element) {
		// Calculate offset to position heading at top of viewport
		const headerOffset = 80; // Larger offset to ensure heading appears at top
		const elementPosition = element.offsetTop;
		const offsetPosition = elementPosition - headerOffset;

		window.scrollTo({
			top: Math.max(0, offsetPosition), // Ensure we don't scroll above page top
			behavior: 'smooth',
		});
	}

	function initScrollHighlighting(headings) {
		if (!headings.length) return;

		// Create intersection observer for scroll tracking
		const observerOptions = {
			root: null,
			rootMargin: '-20% 0% -70% 0%', // Trigger when heading is in top 20-30% of viewport
			threshold: 0,
		};

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				const headingId = entry.target.id;
				const tocLink = document.querySelector(`[data-target="${headingId}"]`);

				// Intersection tracking removed - no longer updating active states
			});
		}, observerOptions);

		// Observe all headings
		headings.forEach((heading) => {
			observer.observe(heading);
		});

		// Handle page load with hash
		if (window.location.hash) {
			setTimeout(() => {
				const targetElement = document.querySelector(window.location.hash);
				if (targetElement) {
					// Just scroll to the element, no active state tracking
					smoothScrollToElement(targetElement);
				}
			}, 100);
		}
	}

	// Active state tracking removed per user request

	function escapeHtml(text) {
		const div = document.createElement('div');
		div.textContent = text;
		const escaped = div.innerHTML;
		console.log('🔍 TOC: Escaped HTML:', { original: text, escaped: escaped });
		return escaped;
	}

	// ============================================================================
	// SOCIAL SHARE FUNCTIONALITY
	// ============================================================================

	function initSocialShare() {
		console.log('🚀 Social Share: Initializing social share functionality...');

		const socialShareButtons = document.querySelectorAll('.social-share-btn');

		if (socialShareButtons.length === 0) {
			console.log('⚠️ Social Share: No social share buttons found');
			return;
		}

		console.log(
			'✅ Social Share: Found',
			socialShareButtons.length,
			'social share buttons'
		);

		// Handle VK button visibility based on locale
		const vkButton = document.querySelector('.social-share-vk');
		if (vkButton) {
			const locale = vkButton.getAttribute('data-locale');
			console.log('🌍 Social Share: Detected locale:', locale);

			if (locale === 'ru') {
				vkButton.style.display = 'inline-flex';
				console.log('✅ Social Share: VK button shown for Russian locale');
			} else {
				vkButton.style.display = 'none';
				console.log('🚫 Social Share: VK button hidden for non-Russian locale');
			}
		}

		socialShareButtons.forEach((button) => {
			button.addEventListener('click', handleSocialShare);
		});
	}

	function handleSocialShare(e) {
		e.preventDefault();

		const button = e.currentTarget;
		const social = button.getAttribute('data-social');
		const url = button.getAttribute('data-url');
		const title = button.getAttribute('data-title');

		console.log('🔗 Social Share: Sharing to', social, { url, title });

		// Encode URL and title for sharing
		const encodedUrl = encodeURIComponent(url);
		const encodedTitle = encodeURIComponent(title);

		let shareUrl = '';

		switch (social) {
			case 'facebook':
				shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
				break;
			case 'twitter':
				shareUrl = `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`;
				break;
			case 'linkedin':
				shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
				break;
			case 'vk':
				shareUrl = `https://vk.com/share.php?url=${encodedUrl}&title=${encodedTitle}`;
				break;
			default:
				console.error('❌ Social Share: Unknown social platform:', social);
				return;
		}

		// Open share window
		if (shareUrl) {
			const windowFeatures =
				'width=600,height=400,scrollbars=yes,resizable=yes';
			const shareWindow = window.open(shareUrl, 'share', windowFeatures);

			// Focus the share window
			if (shareWindow) {
				shareWindow.focus();
			}

			console.log('✅ Social Share: Opened share window for', social);
		}
	}

	/**
	 * Generate FAQ Schema from Table of Contents
	 * Creates structured data for search engines based on article headings
	 */
	function generateFAQSchema() {
		console.log('🔍 FAQ Schema: Checking for TOC...');
		
		const toc = document.getElementById('table-of-contents');
		if (!toc || !toc.classList.contains('has-headings')) {
			console.log('⚠️ FAQ Schema: No TOC found or no headings');
			return;
		}

		console.log('✅ FAQ Schema: TOC found, generating schema...');

		const items = Array.from(document.querySelectorAll('.gh-toc-link'))
			.map((link) => {
				const href = link.getAttribute('href');
				if (!href) return null;

				const heading = document.querySelector(href);
				if (!heading) return null;

				// Find content after heading until next heading
				let content = '';
				let nextEl = heading.nextElementSibling;
				while (nextEl && !nextEl.matches('h1, h2, h3, h4, h5, h6')) {
					if (nextEl.textContent) {
						content += nextEl.textContent + ' ';
					}
					nextEl = nextEl.nextElementSibling;
				}

				return {
					question: heading.textContent.trim(),
					answer: content.trim().substring(0, 300),
				};
			})
			.filter(Boolean);

		console.log(`🔍 FAQ Schema: Found ${items.length} potential FAQ items`);

		if (items.length >= 3) {
			const schema = {
				'@context': 'https://schema.org',
				'@type': 'FAQPage',
				mainEntity: items.map((item) => ({
					'@type': 'Question',
					name: item.question,
					acceptedAnswer: {
						'@type': 'Answer',
						text: item.answer,
					},
				})),
			};

			const script = document.createElement('script');
			script.type = 'application/ld+json';
			script.textContent = JSON.stringify(schema);
			document.head.appendChild(script);

			console.log('✅ FAQ Schema: Schema added to page with', items.length, 'items');
		} else {
			console.log('⚠️ FAQ Schema: Not enough items (need 3+), found', items.length);
		}
	}

	// Initialize FAQ Schema generation
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', generateFAQSchema);
	} else {
		generateFAQSchema();
	}
})();
